<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      :width="1000"
      :ok-button-props="{ props: { loading: submitting } }"
      title="发送讣告"
      @ok="handleSubmit"
    >
      <span>请确认并维护以下信息：</span>
      <a-form
        class="custom-compact-form"
        style="margin-top:20px;"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >
        <a-row>
          <a-col :span="12">
            <a-form-item label="逝者姓名">
              <a-input
                :disabled="true"
                v-decorator="['deadName', {
                  normalize: this.$lodash.trim
                }]"
                autocomplete="off"
              />
            </a-form-item>
            <a-form-item label="逝世日期">
              <a-input
                :disabled="true"
                v-decorator="['deadTime', {
                  normalize: this.$lodash.trim
                }]"
                autocomplete="off"
              />
            </a-form-item>
            <a-form-item label="年龄">
              <a-input
                :disabled="true"
                v-decorator="['age', {
                  normalize: this.$lodash.trim
                }]"
                autocomplete="off"
              />
            </a-form-item>
            <a-form-item label="性别">
              <a-input
                :disabled="true"
                v-decorator="['gender', {
                  normalize: this.$lodash.trim
                }]"
                autocomplete="off"
              />
            </a-form-item>
            <a-form-item label="发布人">
              <a-input
                v-decorator="['master_name', {
                  normalize: this.$lodash.trim
                }]"
                autocomplete="off"
              />
            </a-form-item>
            <a-form-item label="发布日期">
              <a-date-picker
                style="width: 100%;"
                v-decorator="['make_at', {
                  rules: [
                    { required: true, message: `请选择发布日期` }
                  ]
                }]"
              />
            </a-form-item>
            <a-form-item label="抬头">
              <a-input
                v-decorator="['title', {
                  normalize: this.$lodash.trim
                }]"
                autocomplete="off"
              />
            </a-form-item>
            <a-form-item label="讣告内容">
              <a-textarea
                v-decorator="['content', {
                  normalize: this.$lodash.trim,
                  rules: [
                    { max: 1000, message: '最多1000个字符' },
                    { required: true, message: '请输入讣告内容' }
                  ]
                }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="地址检索">
              <a-input-search
                style="width: 100%;"
                v-decorator="['address_search', {
                  normalize: this.$lodash.trim,
                  rules: [
                    { max: 6, message: '最多6个字符' },
                  ]
                }]"
                enter-button="定位"
                @search="location"
              />
            </a-form-item>
            <a-form-item label="吊唁地址">
              <a-select
                v-decorator="['mourning_address']"
                placeholder="请选择吊唁地址"
                allow-clear
                @change="changLocation"
              >
                <a-select-option
                    v-for="(location,index) in locationOptions"
                    :key="index"
                    :value="index"
                >
                  {{ location.title }}({{ location.address }})
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="详细地址">
              <a-input
                v-decorator="['mourning_address_detail', {
                  rules: [{ max: 100, message: '最多100个字符'}]
                }]"
                autocomplete="off"
              />
            </a-form-item>
            <div ref="container" />
          </a-col>
        </a-row>
      </a-form>
      <template slot="footer">
        <a-button class="ant-btn-default" @click="closeModal">
          关闭
        </a-button>
        <a-button class="ant-btn-primary" @click="handleSubmit" :loading="submitting">
          生成图片
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>

import { makeObituary, findObituaryInfo } from '@/api/order'
import { formatDate } from '@/utils/time'
import { locationSearch } from '@/api/map'

export default {
  name: 'SendObituary',
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    serviceOrderId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'send_obituary' }),
      submitting: false,
      data: {},
      locationOptions: [],
      longitude: 0,
      latitude: 0,
      address: '',
      locationTitle: '',
      createMap: true,
      marker: undefined,
      amap: undefined
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchFormData()
  },
  methods: {
    fetchFormData() {
      findObituaryInfo(this.serviceOrderId, {}).then((res) => {
        this.longitude = res.data.longitude
        this.latitude = res.data.latitude
        this.address = res.data.mourning_address

        this.form.setFieldsValue({
          deadName: res.data.deadName,
          deadTime: res.data.deadTime,
          age: res.data.age,
          gender: res.data.gender,
          master_name: res.data.releasePerson,
          make_at: this.$moment(res.data.releaseTime),
          title: res.data.title,
          content: res.data.content,
          mourning_address: res.data.mourning_address,
          mourning_address_detail: res.data.mourning_address_detail
        })
      })
    },

    closeModal() {
      this.isShow = false
    },

    initMap() {
      const center = new TMap.LatLng(31.981234, 120.894518)
      const map = new TMap.Map(this.$refs.container, {
        center: center,
        zoom: 13
      })
      const marker = new TMap.MultiMarker({
        map: map,
        styles: {
          current: new TMap.MarkerStyle({
            width: 34,
            height: 46,
            anchor: { x: 36, y: 32 },
            src: 'https://res.anxiaotang.com/assets/d273876b-2874-4d50-bf7a-7d623845c0e8',
            color: '#333',
            size: 16,
            direction: 'bottom',
            strokeColor: '#fff',
            offset: { x: 0, y: 0 },
            strokeWidth: 2
          })
        },
        geometries: []
      })
      this.marker = marker
      this.amap = map
      this.createMap = false
    },
    changLocation(val) {
      if (val) {
        const location = this.locationOptions[val]
        this.longitude = location.location.lng
        this.latitude = location.location.lat
        this.locationTitle = location.title
        this.address = this.locationTitle
        this.form.setFieldsValue({ mourning_address_detail: location.address })
        this.initMarkers(location.title, location.location.lat, location.location.lng)
      } else {
        this.form.setFieldsValue({ mourning_address_detail: undefined })
        this.longitude = 0
        this.latitude = 0
        this.address = ''
        this.locationTitle = ''
        if (this.marker) {
          this.initMarkers('', 31.981234, 120.894518)
        }
      }
    },
    initMarkers(title, lat, lng) {
      const currentLatLng = new TMap.LatLng(lat, lng)
      this.marker.updateGeometries([
        {
          styleId: 'current',
          id: '1',
          position: currentLatLng,
          content: title // 标注点文本
        }
      ])
      this.amap.setCenter(currentLatLng)
    },
    location() {
      this.onSearch()
      if (this.createMap === true) {
        this.initMap()
      }
    },
    onSearch() {
      const name = this.form.getFieldValue('address_search')
      locationSearch({ keyword: name, page_size: 10 }).then(res => {
        if (res.code === 0 && res.data.status === 0) {
          this.locationOptions = res.data.data
        }
      })
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }
      this.$info({
        title: '正在生成讣告图片，请耐心等候',
        content: ''
      })
      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          values.mourning_address = this.address
          values.make_at = formatDate(values.make_at)
          makeObituary(this.serviceOrderId, values).then((res) => {
            if (res.code === 0) {
              // 关闭模态框
              this.isShow = false
              // 告知父组件已完成
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>
